<div *ngIf="!tooltip.showTooltip"class="wrapper u-flex u-col-align-center u-justify-center u-flex-col u-cursor-pointer u-w-18" [ngClass]="{'disabled': disabled}">
    <i [ngClass]="(iconClass && !matIcon)? iconClass:'material-icons'" class="u-text-xxxl">{{matIcon}}</i>
    <span class="u-pt-1 u-text-xxs" *ngIf="label">{{label}}</span>
</div>
<div *ngIf="tooltip.showTooltip"class="wrapper u-w-18" [ngClass]="{'disabled u-bg-gray-100': disabled}" pTooltip="{{tooltip.tooltipText}}" tooltipPosition="{{tooltip.tooltipPosition || 'bottom'}}">
    <i *ngIf="tooltip.showTooltip"[ngClass]="(iconClass && !matIcon)? iconClass:'material-icons'" class="u-text-xxl">{{matIcon}}</i>
    <span class="label u-pt-1 u-text-xxs" *ngIf="label">{{label}}</span>
</div>
